import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        endDate: String,
        serverTime: String,
        labelMonth: { type: String, default: 'month' },
        labelMonths: { type: String, default: 'months' },
        labelDay: { type: String, default: 'day' },
        labelDays: { type: String, default: 'days' },
    }

    static targets = ['display']

    connect() {
        // Calculate the offset between server time and client time
        this.serverTimeOffset = 0;
        if (this.hasServerTimeValue && this.serverTimeValue) {
            const serverDate = new Date(this.serverTimeValue);
            const clientDate = new Date();
            this.serverTimeOffset = serverDate - clientDate;
        }

        this.updateCountdown();
        this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnect() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    getCurrentServerTime() {
        return new Date(Date.now() + this.serverTimeOffset);
    }

    updateCountdown() {
        const endDate = new Date(this.endDateValue);
        const now = this.getCurrentServerTime();

        if (endDate <= now) {
            this.displayTarget.textContent = '00:00:00';
            clearInterval(this.interval);
            return;
        }

        const { months, days, hours, minutes, seconds } = this.calculateTimeDifference(now, endDate);

        let displayParts = [];

        if (months > 0) {
            const monthLabel = months === 1 ? this.labelMonthValue : this.labelMonthsValue;
            displayParts.push(`${months} ${monthLabel}`);
        }

        if (days > 0 || months > 0) {
            const dayLabel = days === 1 ? this.labelDayValue : this.labelDaysValue;
            displayParts.push(`${days} ${dayLabel}`);
        }

        const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        displayParts.push(timeString);

        this.displayTarget.textContent = displayParts.join(' ');
    }

    calculateTimeDifference(startDate, endDate) {
        let start = new Date(startDate);
        let end = new Date(endDate);

        // Calculate months
        let months = 0;
        let tempDate = new Date(start);

        while (true) {
            // Try adding one month
            let nextMonth = new Date(tempDate);
            nextMonth.setMonth(nextMonth.getMonth() + 1);

            if (nextMonth <= end) {
                months++;
                tempDate = nextMonth;
            } else {
                break;
            }
        }

        // Calculate remaining days after months
        let days = 0;
        while (true) {
            let nextDay = new Date(tempDate);
            nextDay.setDate(nextDay.getDate() + 1);

            if (nextDay <= end) {
                days++;
                tempDate = nextDay;
            } else {
                break;
            }
        }

        // Calculate remaining hours, minutes, seconds
        const remainingMs = end - tempDate;
        const hours = Math.floor(remainingMs / (1000 * 60 * 60));
        const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000);

        return { months, days, hours, minutes, seconds };
    }
}